import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, Suspense as _Suspense, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5f7a04a5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "brand-auth white flex-col" }

import ToolBar from '@/components/bussiness/ToolBar.vue'
import Form from './Form.vue'

import { useRoute } from 'vue-router'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { query } = useRoute()


return (_ctx: any,_cache: any) => {
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(ToolBar),
    _createVNode(_component_el_scrollbar, { class: "fx-1" }, {
      default: _withCtx(() => [
        (_openBlock(), _createBlock(_Suspense, null, {
          default: _withCtx(() => [
            _createVNode(Form, _normalizeProps(_guardReactiveProps(_unref(query))), null, 16)
          ]),
          _: 1
        }))
      ]),
      _: 1
    })
  ]))
}
}

})